import { render, staticRenderFns } from "./VuesticPalletCustom.vue?vue&type=template&id=30a9395c"
import script from "./VuesticPalletCustom.vue?vue&type=script&lang=js"
export * from "./VuesticPalletCustom.vue?vue&type=script&lang=js"
import style0 from "./VuesticPalletCustom.vue?vue&type=style&index=0&id=30a9395c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports